module.exports = __webpack_public_path__ + "static/media/logo-big.06d57d8a.png";